import { useMemo } from "react";
import { v4 as uuidv4 } from "uuid";

/**
 * generates a random ID for an HTML element so it can
 * be used for e.g. `aria-labelledby`.  stable across
 * rerenders.
 * @returns a random ID
 */
export function useRandomId(): string {
  return useMemo(() => uuidv4(), []);
}
